import './whatsapp_message_content.js.coffee'

Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.WhatsappLocationMessageContent extends Monitoring.Models.SocialContents.WhatsappMessageContent

  getMainText: ->
    @json.whatsappMessage.name + " - " + @json.whatsappMessage.address

  getLatitude: ->
    @json.whatsappMessage.latitude

  getLongitude: ->
    @json.whatsappMessage.longitude
